import { Tab, TabList, TabPanel, Tabs } from 'react-tabs'
import styled from 'styled-components'

export const StyledTabList = styled(TabList)`
  display: flex;
  align-items: start;
  justify-content: center;
  width: 100%;
  padding: 0 15px;
`

export const StyledTab = styled(Tab)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0;
  min-height: 30px;
  border: 1px solid ${props => props.theme.colors.secondaryLight};
  border-top: 0;
  color: ${props => props.theme.colors.secondary};
  font-size: 12px;
  text-align: center;
  text-decoration: none;
  background: ${props => props.theme.colors.white};

  &.react-tabs__tab--selected {
    font-weight: 600;
  }
  &:first-child {
    border-bottom-left-radius: 4px;
  }
  &:last-child {
    border-bottom-right-radius: 4px;
  }
  &:hover {
    cursor: pointer;
    background: ${props => props.theme.colors.secondaryLighter};
  }
`
export const StyledTabPanel = styled(TabPanel)``
export const StyledTabs = styled(Tabs)``



// WEBPACK FOOTER //
// ./src/components/Tabs/theme.js